import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ROOT_URL } from "../../api/ApiConfig";

export const updateKbArticle = createAsyncThunk(
  "kbArticle/updateKbArticle",
  async (
    { articleId, title, content, categoryIds, visibility, tagIds, status, disableComments, group_id },
    { getState, rejectWithValue }
  ) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      if (!articleId) {
        throw new Error("Article ID is required");
      }

      const url = `${ROOT_URL}/kb/article/${articleId}`;

      const payload = {
        title,
        content,
        categoryIds,
        visibility,
        tagIds,
        status,
        disableComments,
        group_id
      };

      const response = await axios.put(url, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const updateKbArticleSlice = createSlice({
  name: "updateKbArticle",
  initialState,
  reducers: {
    resetUpdateState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateKbArticle.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateKbArticle.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateKbArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetUpdateState } = updateKbArticleSlice.actions;
export default updateKbArticleSlice.reducer;
